var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-align-icon"},[_c('svg',{attrs:{"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":_vm.svgData,"fill":_vm.color}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }